import { CRM_PRODUCT_ID, DEV_PRODUCT_ID, WORK_MANAGEMENT_PRODUCT_ID } from "constants/products";

export default {
  maxLimit: 3,
  showDivider: false,
  backgroundColor: "transparent",
  tabs: [
    {
      title: {
        title: "Work Management",
        body: "Manage all aspects of work, from strategy to execution."
      },
      content: {
        productType: WORK_MANAGEMENT_PRODUCT_ID,
        ctaText: "Try work management",
        useCases: [],
        features: []
      }
    },
    {
      title: {
        title: "monday sales",
        body: "Streamline the sales cycle, from lead to close."
      },
      content: {
        productType: CRM_PRODUCT_ID,
        ctaText: "Try Sales CRM",
        useCases: [],
        features: []
      }
    },
    {
      title: {
        title: "Dev",
        body: "Ship better products, from concept to launch."
      },
      content: {
        productType: DEV_PRODUCT_ID,
        ctaText: "Try Dev",
        useCases: [],
        features: []
      }
    }
  ],
  timerEnabled: false,
  showButton: false,
  arrowSize: "12px",
  showArrow: true,
  title: {
    fontSize: "24px",
    selectedFontSize: "24px"
  }
};
